var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-3",attrs:{"exact":_vm.exact,"to":{ name: _vm.to },"text":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.to)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }